import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/** Abre um registro específico quando a URL traz ?param=ID (busca universal do topo). */
export const useDeepLink = (param, apply) => {
  const [params, setParams] = useSearchParams();
  const value = params.get(param);
  useEffect(() => {
    if (!value) return;
    apply(value);
    const next = new URLSearchParams(params);
    next.delete(param);
    setParams(next, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
};
